/* eslint-disable camelcase */
import { Vue, Component } from 'vue-property-decorator'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

@Component
export class PromisesMixin extends Vue {
    $_handleErrors(response: EntityIdentifierWithErrorResponse[]): void {
        PromiseUtils.handleErrors(response)
    }

    $_handleAxiosError(error: any, excludedResponseStatuses?: number[]): void {
        PromiseUtils.handleAxiosError(error, excludedResponseStatuses)
    }

    /** @deprecated */
    async $_toCall(promise: Promise<any>, showError: boolean = false): Promise<any[]> {
        return PromiseUtils.toCall(promise, showError)
    }

    async $_toCallSecure<T>(promise: Promise<T>, errorHandler?: (error: any) => void): Promise<T | null> {
        return PromiseUtils.toCallSecure<T>(promise, errorHandler)
    }
    async $_toCallSecureLoading<T>(promise: Promise<T>, errorHandler?: (error: any) => void): Promise<T | null> {
        return PromiseUtils.toCallSecureLoading<T>(promise, errorHandler)
    }
    async $_toCallUnique<T>(promise: Promise<T>, errorHandler?: (error: any) => void): Promise<T | null> {
        return PromiseUtils.toCallUnique<T>(promise, errorHandler)
    }
}
